.container {
  color: var(--dds-color-text-default);
}

.container--readonly {
  color: var(--dds-color-text-medium);
}

.container--disabled {
  color: var(--dds-color-text-subtle);
}

.input--extended {
  width: 100%;
}

.affix {
  height: 100%;
  display: flex;
  align-items: center;
  pointer-events: none;
}

.prefix {
  left: 0;
  margin-left: var(--dds-spacing-x0-5);
  padding-right: var(--dds-spacing-x0-5);
  border-right: 1px solid var(--dds-color-border-default);
}

.suffix {
  right: 0;
  margin-right: var(--dds-spacing-x0-5);
  padding-left: var(--dds-spacing-x0-5);
  border-left: 1px solid var(--dds-color-border-default);
}

.affix--disabled {
  border-color: var(--dds-color-border-subtle);
}
